import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import { AuthProvider } from './auth/AuthProvider'
import { TvApp } from './tv/TvApp'
import './styles.css'

/**
 * To indgange i samme kodebase (kravspec afsnit 53):
 *
 * - /tv   : TV-visningen. Ingen Microsoft-login, ingen navigation - kun device token.
 * - alt andet: bruger- og adminpanelet med Entra ID-login.
 *
 * TV-visningen holdes uden for MSAL, så en skærm aldrig kan komme til at bruge
 * et brugerlogin (kravspec afsnit 26).
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 30_000
    }
  }
})

const isTvRoute = window.location.pathname.startsWith('/tv')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isTvRoute ? (
      <TvApp />
    ) : (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    )}
  </StrictMode>
)
